@import "../../../globals/main.scss";

pn-qr-code-generator {
  display: block;
  text-align: center;

  canvas {
    border: 1px solid $gray200;
    transition: filter 0.3s ease;
    width: 20rem;
    height: 20rem;
  }
  
  canvas.outdated {
    filter: grayscale(100%);
  }
  
  .timer {
    margin-top: 1rem;
    text-align: center;
    font-size: 1.4rem;
    color: $gray900;
  }
  
  .outdated-message {
    color: $warning;
  }

  .qr-button__wrapper {
    background: transparent;
    border: none;
    padding: 0;
    width: 20rem;
    height: 20rem;

    &:focus,
    &:focus-visible {
      outline-color: $blue700;
    }
  }
}